import { useTranslation } from '@/app/components/translations/Translation';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider';
import { BRAND_IMAGES, getBrandImageUrl } from '@/app/common/contentHubAssets.ts';
import { Icon } from '@/app/common/icons/Icon';
import {
  TaxesIncludedTooltipCaret,
  TaxesIncludedTooltipCloseButton,
  TaxesIncludedTooltipContent,
  TaxesIncludedTooltipImage,
  TaxesIncludedTooltipInner,
  TaxesIncludedTooltipText,
  TaxesIncludedTooltipTextContainer,
  TaxesIncludedTooltipWrapper,
} from './styled';

type TaxesIncludedTooltipProps = {
  onDismiss: () => void;
};

const TaxesIncludedTooltip = ({ onDismiss }: TaxesIncludedTooltipProps) => {
  const { t } = useTranslation();
  const { localization } = usePageWrapperData();

  const image = getBrandImageUrl(BRAND_IMAGES.DEPOSIT, localization);

  return (
    <TaxesIncludedTooltipWrapper role="tooltip">
      <TaxesIncludedTooltipCaret aria-hidden="true" />
      <TaxesIncludedTooltipContent>
        <TaxesIncludedTooltipInner>
          <TaxesIncludedTooltipImage src={image} alt="" />
          <TaxesIncludedTooltipTextContainer>
            <TaxesIncludedTooltipText>{t('vacation.oss.taxes_included.tooltip.text1')}</TaxesIncludedTooltipText>
            <TaxesIncludedTooltipText>{t('vacation.oss.taxes_included.tooltip.text2')}</TaxesIncludedTooltipText>
          </TaxesIncludedTooltipTextContainer>
        </TaxesIncludedTooltipInner>
        <TaxesIncludedTooltipCloseButton
          type="button"
          aria-label={t('vacation.oss.cards.map.close')}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onDismiss();
          }}
        >
          <Icon category="Semantics" name="icon-cross" size={20} color="iconOnDark" alt="" />
        </TaxesIncludedTooltipCloseButton>
      </TaxesIncludedTooltipContent>
    </TaxesIncludedTooltipWrapper>
  );
};

export default TaxesIncludedTooltip;
